import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-one-simple-view",
  templateUrl: "./axle-one-simple-view.component.html",
  styleUrls: ["./axle-one-simple-view.component.scss"],
})
export class AxleOneSimpleViewComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() veiculoId: number;

  public sensorOneLeftSelect: any = [];
  public sensorOneRightSelect: any = [];

  public sensorOneRightCombo: any = [];
  public sensorOneLeftCombo: any = [];

  public axisOneSimpleLeftForm: FormGroup;
  public axisOneSimpleRightForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.axisOneSimpleLeftForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneSimpleRightForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisOneSimpleLeftForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 ESQ"
      );
      this.axisOneSimpleRightForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 DIR"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo1Direito = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          36
        );

        const eixo1Esquerdo = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          35
        );

        // EIXO 1 DIREITO
        if (eixo1Direito != null) {
          this.axisOneSimpleRightForm.controls["id"].setValue(eixo1Direito.id);

          if (eixo1Direito.sensor != null) {
            appendSensorToCombo(this.sensorOneRightCombo, eixo1Direito.sensor);
            this.sensorOneRightSelect = eixo1Direito.sensor.id;
          }

          if (eixo1Direito.pneu != null) {
            this.axisOneSimpleRightForm.controls["pneu"].setValue(
              eixo1Direito.pneu.numeroFogo
            );
          }

          this.axisOneSimpleRightForm.controls["nrPressaoMinima"].setValue(
            eixo1Direito.nrPressaoMinima
          );

          this.axisOneSimpleRightForm.controls["nrPressaoMaxima"].setValue(
            eixo1Direito.nrPressaoMaxima
          );

          this.axisOneSimpleRightForm.controls["nrTemperaturaMaxima"].setValue(
            eixo1Direito.nrTemperaturaMaxima
          );
        }

        // EIXO 1 ESQUERDO
        if (eixo1Esquerdo != null) {
          this.axisOneSimpleLeftForm.controls["id"].setValue(eixo1Esquerdo.id);

          if (eixo1Esquerdo.sensor != null) {
            appendSensorToCombo(this.sensorOneLeftCombo, eixo1Esquerdo.sensor);
            this.sensorOneLeftSelect = eixo1Esquerdo.sensor.id;
          }

          if (eixo1Esquerdo.pneu != null) {
            this.axisOneSimpleLeftForm.controls["pneu"].setValue(
              eixo1Esquerdo.pneu.numeroFogo
            );
          }

          this.axisOneSimpleLeftForm.controls["nrPressaoMinima"].setValue(
            eixo1Esquerdo.nrPressaoMinima
          );

          this.axisOneSimpleLeftForm.controls["nrPressaoMaxima"].setValue(
            eixo1Esquerdo.nrPressaoMaxima
          );

          this.axisOneSimpleLeftForm.controls["nrTemperaturaMaxima"].setValue(
            eixo1Esquerdo.nrTemperaturaMaxima
          );
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
